import { QueryConfig } from "store/utils/query-config";

export const activityDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["timestamp"]
  }
};
